// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__7asFu","detailsBorder":"styles_detailsBorder__uSOvN"};